import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import UserRepository from "src/repository/Admin/UserRepository";

export const getUserList = createAsyncThunk('get_user_list', async (params) => {
    return await new UserRepository().getUserList(params)
});

export const getUserDetail = createAsyncThunk('get_user_detail', async (userId) => {
    return await new UserRepository().getUserDetail(userId)
});

export const getUserShippingDetail = createAsyncThunk('get_user_shipping_address_detail', async (userId) => {
    return await new UserRepository().getUserShippingDetail(userId)
});
export const getUserAcctList = createAsyncThunk('get_user_acct_list', async (userId) => {
    return await new UserRepository().getUserAcctList(userId)
});
export const getUserSearchAcctList = createAsyncThunk('get_user_search_acct_list', async (params) => {
    return await new UserRepository().getUserSearchAcctList(params)
});
export const getSearchSponsorAccounts = createAsyncThunk('get_search_sponsor_accounts_list', async (params) => {
    return await new UserRepository().searchSponsorAccounts(params)
});

const slice = createSlice({
    name: "User",
    initialState: {
        totalRecords: 0,
        filteredRecords: 0,
        userList: [],
        userShippingAddress:[],
        userDetail: {},
        userAcctList: [],
        userSearchAcctList: [],
        userSearchAcctPopupStatus: false,
        roleSelectionPopUpStatus: false,
        selectedRoles: '',
        selectedRoleIndex: null,
        searchSponsorAccounts: []
    },
    reducers: {
        setUserList: {
            reducer: (state, action) => {
                state.userList = action.payload;
                return state;
            },
        },
       
        setUserAcctList: {
            reducer: (state, action) => {
                state.userAcctList = action.payload;
                return state;
            },
        },
        setUserSearchAcctList: {
            reducer: (state, action) => {
                state.userSearchAcctList = action.payload;
                return state;
            },
        },
        setUserSearchAcctPopupStatus: {
            reducer: (state, action) => {
                state.userSearchAcctPopupStatus = action.payload;
                return state;
            },
        },
        setRoleSelectionPopUpStatus: {
            reducer: (state, action) => {
                state.roleSelectionPopUpStatus = action.payload;
                return state;
            },
        },
        setSelectedRoles: {
            reducer: (state, action) => {
                state.selectedRoles = action.payload;
                return state;
            },
        },
        setSelectedRoleIndex: {
            reducer: (state, action) => {
                state.selectedRoleIndex = action.payload;
                return state;
            },
        },
        setSearchSponsorAccounts: {
            reducer: (state, action) => {
                state.searchSponsorAccounts = action.payload;
                return state;
            },
        },
        setSelectedAccounts: {
            reducer: (state, action) => {
                state.selectedAccounts = action.payload;
                return state;
            },
        },
        setSelectedUserSponsorAccounts: {
            reducer: (state, action) => {
                state.selectedUserSponsorAccounts = action.payload;
                return state;
            },
        },
    },
    extraReducers: {
        [getUserList.fulfilled]: (state, action) => {
            state.userList = action.payload.users;
            state.totalRecords = action.payload.total;
            state.filteredRecords = action.payload.users?.length;
        },
        [getUserShippingDetail.fulfilled]: (state, action) => {
            state.userShippingAddress = action.payload
            
        },
        
        [getUserDetail.fulfilled]: (state, { payload }) => {
            state.userDetail = payload
        },
        [getUserAcctList.fulfilled]: (state, { payload }) => {
            state.userAcctList = payload.records;
            state.totalUserRecords = payload.records?.length;
            state.filteredUserRecords = payload.records?.length;
        },
        [getUserSearchAcctList.fulfilled]: (state, { payload }) => {
            state.userSearchAcctList = payload.records;
        },
        [getSearchSponsorAccounts.fulfilled]: (state, action) => {
            state.searchSponsorAccounts = action.payload.data?.data?.accountList;
        }
    },
});



export let { setUserList, setUserSearchAcctList, setUserSearchAcctPopupStatus, setRoleSelectionPopUpStatus, setSelectedRoles, setSelectedRoleIndex, setUserAcctList, setSelectedAccounts, setSelectedUserSponsorAccounts, setSearchSponsorAccounts } = slice.actions;

export default slice.reducer;
